// extracted by mini-css-extract-plugin
export default {"badge":"MicrositeDomainTypeBadge_badge__AW5F6","tone_custom":"MicrositeDomainTypeBadge_tone_custom__KzZqq","tone_subdomain":"MicrositeDomainTypeBadge_tone_subdomain__Ae+H4"};